export async function mapAsync<T, U>(
    array: T[],
    callback: (value: T, index: number, array: T[]) => Promise<U>
): Promise<U[]> {
    const result: U[] = [];
    for (let i = 0; i < array.length; i++) {
        result.push(await callback(array[i], i, array));
    }
    return result;
}